module.exports = __webpack_public_path__ + "img/ana-dashboard-homeicon.9a272520.png";